var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex",staticStyle:{"display":"flex"}},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.content))]),_c('label',{staticClass:"label",staticStyle:{"color":"rgba(0, 0, 0, 0.6)"}},[_vm._v("*")])])
}
var staticRenderFns = []

export { render, staticRenderFns }